<template>
  <div class="mobile-tourist-page" :style="themeVariables">
    <main class="mobile-tourist-content">
      <section class="form-panel">
        <div class="form-heading">
          <h2>登录个人信息</h2>
        </div>

        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="formRules"
          label-position="left"
          class="mobile-tourist-form"
          @submit.native.prevent="submitForm('ruleForm')"
        >
          <el-form-item
            v-for="(item, index) in fieldList"
            :key="item.id"
            :label="item.showName"
            :prop="item.bizName"
            class="field-item"
            :class="{
              'last-field-item': index === fieldList.length - 1
            }"
          >
            <span slot="label" class="field-label-text">{{ item.showName }}</span>
            <el-input
              v-if="item.inputType === 'TXT'"
              v-model="ruleForm[item.bizName]"
              :maxlength="hasMaxlength(item.bizName)"
              :placeholder="`请输入${item.showName}`"
              class="tourist-control"
            ></el-input>
            <el-radio-group
              v-else-if="item.inputType === 'DROP_DOWN_GENDER'"
              v-model="ruleForm.sex"
              class="gender-control"
              :class="{ 'keyboard-focus': keyboardFocus }"
            >
              <el-radio-button v-for="option in sexType" :key="option.value" :label="option.value">
                {{ option.label }}
              </el-radio-button>
            </el-radio-group>
            <el-select
              v-else-if="item.inputType === 'DROP_DOWN_IDTYPE'"
              v-model="ruleForm.idType"
              placeholder="请选择证件类型"
              :popper-append-to-body="false"
              popper-class="mobile-tourist-select-popper"
              class="tourist-control"
            >
              <el-option v-for="option in userIdType" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>
            <mobile-area-picker
              v-else-if="item.inputType === 'DROP_DOWN_REGION'"
              v-model="ruleForm.districtId"
              placeholder="请选择地区"
              :theme-variables="themeVariables"
              class="tourist-area-control"
              @change="regionChange"
            ></mobile-area-picker>
            <el-select
              v-else-if="item.inputType === 'DROP_DOWN_NORMAL'"
              v-model="ruleForm[item.bizName]"
              :placeholder="`请选择${item.showName}`"
              filterable
              :popper-append-to-body="false"
              popper-class="mobile-tourist-select-popper"
              class="tourist-control"
            >
              <el-option v-for="option in item.candidateValues" :key="option" :label="option" :value="option"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="submit-item">
            <button class="submit-button" type="submit">确 认</button>
          </el-form-item>
        </el-form>
      </section>
    </main>
  </div>
</template>

<script>
import TouristPage from './index'
import MobileAreaPicker from './MobileAreaPicker.vue'

export default {
  name: 'MobileTouristPage',
  extends: TouristPage,
  components: { MobileAreaPicker },
  data() {
    return { keyboardFocus: false }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyboardInput, true)
    document.addEventListener('pointerdown', this.onPointerInput, true)
    document.addEventListener('mousedown', this.onPointerInput, true)
    document.addEventListener('touchstart', this.onPointerInput, true)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyboardInput, true)
    document.removeEventListener('pointerdown', this.onPointerInput, true)
    document.removeEventListener('mousedown', this.onPointerInput, true)
    document.removeEventListener('touchstart', this.onPointerInput, true)
  },
  methods: {
    onKeyboardInput(event) {
      if (['Tab', 'Enter', ' ', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
        this.keyboardFocus = true
      }
    },
    onPointerInput() {
      this.keyboardFocus = false
    },
    regionChange(ids = [], nodes = []) {
      if (ids.length === 3 && nodes.length === 3) {
        window.localStorage.setItem('TOURISTSCITY', nodes.map(node => node.name).join(''))
      } else {
        window.localStorage.removeItem('TOURISTSCITY')
      }
    }
  },
  computed: {
    themeVariables() {
      const color = (this.theme.themeColor || '#00c882').replace(';', '')
      return {
        '--mobile-theme': color,
        '--mobile-theme-light': (this.theme.themeSubColor || '#f2fcf9').replace(';', ''),
        '--mobile-button-background': (this.theme.buttonBackground || color).replace(';', '')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-tourist-page {
  box-sizing: border-box;
  min-height: 100%;
  color: #333;
  background: var(--mobile-theme-light);
}

.mobile-tourist-content {
  width: 100%;
  margin: 0 auto;
  padding: 2rem 1rem 2.5rem;
}

.form-panel {
  width: 100%;
  max-width: 21.4375rem;
  margin: 0 auto;
  padding: 2rem 1rem 2.25rem;
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0.375rem 0.75rem rgba(11, 59, 47, 0.06);
}

.form-heading {
  margin-bottom: 2.25rem;
  text-align: center;
}

.form-heading h2 {
  margin: 0;
  color: #333;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.5rem;
}

.mobile-tourist-form {
  /deep/ .mobile-tourist-select-popper .el-select-dropdown__item.selected {
    color: var(--mobile-theme);
  }
  /deep/ .tourist-control { width: 100%; }
  /deep/ .tourist-area-control { width: 100%; }
  /deep/ .el-form-item.is-error .area-trigger { border-color: #f5222d; }
  /deep/ .field-item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    margin-bottom: 1.25rem;
  }
  /deep/ .field-item::before,
  /deep/ .field-item::after {
    display: none;
  }
  /deep/ .field-item.last-field-item { margin-bottom: 1.5rem; }
  /deep/ .el-form-item__label {
    display: flex;
    align-items: flex-start;
    float: none;
    width: 100%;
    min-width: 0;
    height: auto;
    padding: 0;
    color: #666;
    font-size: 0.875rem;
    line-height: 1.25rem;
    text-align: left;
  }
  .field-label-text {
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: normal;
  }
  /deep/ .el-form-item.is-required .el-form-item__label::before {
    flex: 0 0 auto;
    margin-right: 0.25rem;
    color: #ff4d4f;
  }
  /deep/ .el-form-item__content {
    flex: 0 1 auto;
    width: 100%;
    min-width: 0;
    margin-left: 0 !important;
    line-height: normal;
  }
  /deep/ .el-form-item__error {
    position: static;
    padding-top: 0.25rem;
    color: #f5222d;
    font-size: 0.625rem;
    line-height: 0.875rem;
    white-space: normal;
    overflow-wrap: anywhere;
  }
  /deep/ .tourist-control,
  /deep/ .tourist-area-control { display: block; }
  /deep/ .el-input__inner,
  /deep/ .el-select .el-input__inner {
    height: 2.5rem;
    padding: 0 1rem;
    color: #606266;
    font-size: 0.875rem;
    line-height: 2.5rem;
    border-color: #d9dfe8;
    border-radius: 0.25rem;
  }
  /deep/ .el-input__inner:focus,
  /deep/ .el-select .el-input.is-focus .el-input__inner { border-color: var(--mobile-theme); }
  /deep/ .gender-control { display: flex; width: 6.25rem; }
  /deep/ .gender-control .el-radio-button,
  /deep/ .gender-control .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
    box-shadow: none;
    outline: none;
    -webkit-tap-highlight-color: transparent;
  }
  /deep/ .gender-control .el-radio-button__inner { -webkit-tap-highlight-color: transparent; }
  /deep/ .gender-control .el-radio-button__inner:hover { color: var(--mobile-theme); }
  /deep/ .gender-control.keyboard-focus .el-radio-button:focus .el-radio-button__inner,
  /deep/ .gender-control.keyboard-focus .el-radio-button.is-focus .el-radio-button__inner {
    outline: 2px solid var(--mobile-theme);
    outline-offset: 2px;
  }
  /deep/ .gender-control .el-radio-button:focus-visible .el-radio-button__inner {
    outline: 2px solid var(--mobile-theme);
    outline-offset: 2px;
  }
  /deep/ .gender-control .el-radio-button__orig-radio:focus-visible + .el-radio-button__inner {
    outline: 2px solid var(--mobile-theme);
    outline-offset: 2px;
  }
  /deep/ .el-radio-button { flex: 0 0 3.125rem; }
  /deep/ .el-radio-button + .el-radio-button { margin-left: -1px; }
  /deep/ .el-radio-button__inner { width: 3.125rem; padding: 0; height: 2.25rem; color: #666; font-size: 0.875rem; line-height: 2.25rem; border-color: #d9dfe8; box-shadow: none; }
  /deep/ .el-radio-button:not(:first-child) .el-radio-button__inner { border-left: 1px solid #d9dfe8; }
  /deep/ .el-radio-button:first-child .el-radio-button__inner { border-radius: 0.25rem 0 0 0.25rem; }
  /deep/ .el-radio-button:last-child .el-radio-button__inner { border-radius: 0 0.25rem 0.25rem 0; }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner { position: relative; z-index: 1; color: #fff; border-color: var(--mobile-theme); background: var(--mobile-theme); box-shadow: none; }
  /deep/ .submit-item { margin: 0; }
  /deep/ .submit-item .el-form-item__content { width: 100%; }
}

.submit-button {
  width: 100%;
  height: 2.75rem;
  color: #fff;
  border: 0;
  border-radius: 0.25rem;
  background: var(--mobile-button-background);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.08);
  font: inherit;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.25rem;
}

@media only screen and (min-width: 48rem) and (max-width: 80rem) {
  .mobile-tourist-content {
    padding: 2rem 1.5rem 3rem;
  }

  .form-panel {
    max-width: 29rem;
    padding: 2rem 2.25rem 2.25rem;
    border-radius: 0.5rem;
  }

  .form-heading {
    margin-bottom: 2rem;
  }

  .form-heading h2 {
    font-size: 1rem;
    line-height: 1.25rem;
  }

  .mobile-tourist-form /deep/ .field-item {
    flex-direction: row;
    align-items: flex-start;
    gap: 0.75rem;
    min-height: 2.25rem;
    margin-bottom: 0.875rem;
  }

  .mobile-tourist-form /deep/ .field-item.last-field-item {
    margin-bottom: 1.5rem;
  }

  .mobile-tourist-form /deep/ .el-form-item__label {
    flex: 0 0 6.5rem;
    width: 6.5rem;
    min-height: 2.25rem;
    padding: 0.5625rem 0;
    font-size: 0.75rem;
    line-height: 1.125rem;
  }

  .mobile-tourist-form /deep/ .el-form-item__content {
    flex: 1;
    width: auto;
  }

  .mobile-tourist-form /deep/ .el-form-item__error {
    padding-top: 0.125rem;
    font-size: 0.5625rem;
    line-height: 0.6875rem;
  }

  .mobile-tourist-form /deep/ .el-input__inner,
  .mobile-tourist-form /deep/ .el-select .el-input__inner {
    height: 2.25rem;
    padding: 0 0.875rem;
    font-size: 0.6875rem;
    line-height: 2.25rem;
  }

  .mobile-tourist-form /deep/ .gender-control {
    width: 6rem;
  }

  .mobile-tourist-form /deep/ .el-radio-button {
    flex-basis: 3rem;
  }

  .mobile-tourist-form /deep/ .el-radio-button__inner {
    width: 3rem;
    height: 2.25rem;
    font-size: 0.6875rem;
    line-height: 2.25rem;
  }

  .submit-button {
    height: 2.25rem;
    font-size: 0.75rem;
  }
}
</style>

<style lang="scss">
@media only screen and (min-width: 48rem) and (max-width: 80rem) {
  .mobile-tourist-select-popper {
    font-size: 0.625rem;
  }

  .mobile-tourist-select-popper .el-select-dropdown__list {
    padding: 0.25rem 0;
  }

  .mobile-tourist-select-popper .el-select-dropdown__item {
    height: 2rem;
    padding: 0 0.875rem;
    font-size: 0.625rem;
    line-height: 2rem;
  }
}
</style>
